import { useState } from "react";
import Tick from "@/assets/icon/svgs/Tick.svg";
interface CheckBoxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const CheckBox: React.FC<CheckBoxProps> = ({ checked = false, onChange }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const toggleCheck = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onChange?.(newValue);
  };

  return (
    <div
      className={`h-8 w-8 flex-shrink-0 border-2 border-[#00000080] rounded-[8px] flex items-center justify-center cursor-pointer ${
        isChecked ? "border-[#0027CB]" : "border-[#00000080]"
      }`}
      onClick={toggleCheck}
    >
      {isChecked && <img src={Tick} alt="tick" />}
    </div>
  );
};

export default CheckBox;
